import { Box, Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import React, { useState } from "react";
import CustomTypography from "../../../../components/common/CustomTypography";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";
import { usePromotionOnboardingTracking } from "../../../../hooks/usePromotionOnboardingTracking";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

interface SelectOption {
  id: number;
  label: string;
}

export const selectOptionList: SelectOption[] = [
  { id: 1, label: "스스로 이겨낼 힘을 기르는 것" },
  { id: 2, label: "재발 없이 확실히 해결하는 것" },
  { id: 3, label: "잘 모르겠음" },
];

export default function Approach_2_V6({
  version = "v6",
}: {
  version?: MktVersionTypes;
}) {
  const [isAnimating, setIsAnimating] = useState(false);

  const pageKey = "approach_2";

  const { singleSelectionId, updateSingleSelection, handleNext } =
    useOnboardingPromotionPage({
      pageKey,
      nextPageRoute: `/${versionToPathPrefix(version)}-onboarding/approach/4`,
    });

  const { trackSingleSelection } = usePromotionOnboardingTracking(pageKey, version);

  const handleOptionChange = (optionId: number) => {
    updateSingleSelection(optionId);
    trackSingleSelection(optionId);

    setTimeout(() => {
      setIsAnimating(false);
      handleNext({ singleSelectionId: optionId });
    }, 300);
  };

  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <Stack spacing={2}>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{ color: theme.vars.palette.Content.Strong }}
        >
          {"마음 문제를 해결할 때, 나에게 가장 중요한 가치는 무엇인가요?"}
        </CustomTypography>
      </Stack>

      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            whiteSpace: "nowrap",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {selectOptionList.map(({ id, label }) => (
            <Stack key={`select_option_${id}`} sx={{ flexGrow: 1, gap: 1 }}>
              <Button
                fullWidth
                variant={"SingleSlim"}
                size={"lg"}
                color={singleSelectionId === id ? "primary" : "secondary"}
                sx={{
                  transition: "background-color 0.3s ease",
                }}
                onClick={() => {
                  handleOptionChange(id);
                }}
              >
                {label}
              </Button>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
